export enum NotificationType{
Submission_Approved=10,
Submission_Denied=20,
New_Data_Submitted=30,
Medication_Report=40,
Invite_Vet_to_Repository=50,
Vet_Sale_Access_Request_Approved=60,
Vet_Sale_Access_Request_Denied=70,
Consignor_Vet_Hit=80,
Vet_Notification=90,
Share_Horse_Study_Data=100,
Consignor_Notification =110
}

export class NotificationTypeDto {
  notificationTypeId: any;
  name: string;
  description: string;
  notificationGroupId: any | null;
  notificationGroupName: string;
  defaultEmailSubject: string | null;
  defaultEmailBody: string | null;
  defaultSMSText: string | null;
  tagLegend: string[];
}

export class UserNotificationType {

  notificationTypeId: any;
  isEnable: boolean;
  name: string;
}
